import React from "react";
import {FilterItem, FilterItemProps, InputEditor, SelectEditor} from "../tablefilter/TableFilter";
import {SearchFilter} from "../tablefilter/SearchFilter";
import {FindingSeverity} from "../../domain/FindingSeverity";

export function createDefaultSbomProjectVersionFilterValues() {
    return {name: "", severity: [], analysisState: []};
}

function NameItem(props: FilterItemProps) {
    return (
        <InputEditor
            value={props.value}
            onChange={props.onChange}
        />
    );
}

function SeverityItem(props: FilterItemProps) {
    return (
        <SelectEditor
            options={Object.keys(FindingSeverity).map(severity => ({
                value: severity,
                label: <span style={{display: "inline-block"}} className={"selection-item-text"}>&gt;= {severity}</span>
            }))}
            multiple={false}
            value={props.value}
            onChange={props.onChange}
        />
    );
}

function AnalysisStateItem(props: FilterItemProps) {
    return (
        <SelectEditor
            width={120}
            popupMatchSelectWidth={140}
            options={[
                {value: "ANALYSED", label: "analysed"},
                {value: "NOT_ANALYSED", label: "not analysed"}
            ]}
            multiple={true}
            value={props.value}
            onChange={props.onChange}
        />
    );
}

interface SbomProjectVersionFilterProps {
    className?: string;
    values?: any;
    onChange: (values: any) => void;
    persistentStateIdent?: string;
}

function SbomProjectVersionFilter(props: SbomProjectVersionFilterProps) {
    const items: FilterItem[] = [
        {
            name: "name",
            key: "name",
            label: "Name",
            render: itemProps => <NameItem {...itemProps}/>
        },
        {
            name: "severity",
            key: "severity",
            label: "Finding severity",
            render: itemProps => <SeverityItem {...itemProps}/>
        },
        {
            name: "analysisState",
            key: "analysisState",
            label: "Analysis",
            render: itemProps => <AnalysisStateItem {...itemProps}/>
        }
    ];

    return (
        <SearchFilter
            items={items}
            className={props.className}
            values={props.values}
            defaultValues={createDefaultSbomProjectVersionFilterValues()}
            persistentStateIdent={props.persistentStateIdent}
            defaultActiveFilterNames={["name", "severity", "analysisState"]}
            onChange={props.onChange}
        />
    );
}

export default SbomProjectVersionFilter;
